import React from 'react';

import { AllFilters as AllFiltersProvider } from 'components/Filters';

import { GeneralSection } from 'scenes/Trackers/components/Filters';
import {
  CreativeFilters,
  CreativeSection,
} from 'scenes/Trackers/CreativeFilters';
import CreativesTrackerApplyButton from '../../CreativesTrackerApplyButton';

import CreativesTrackerFilters from './filters';

import { Tabs, Tab } from '@gogame/components';
import AdvancedFilters, {
  AdvancedFiltersLabel,
} from 'scenes/Trackers/components/AdvancedFilters';
import {
  loadMetricsAdvancedOperators,
  loadMetricsAdvancedList,
} from '../../sources/creativesTracker';
import { useScreenState } from '@gogame/screens';

const FILTERS_TAB_ID = 0;
const ADVANCED_FILTERS_TAB_ID = 1;

const AllFilters = ({ open, onClose, onExited, params }) => {
  const [activeTabId, setActiveTabId] = React.useState(FILTERS_TAB_ID);
  const {
    payToLocked,
    onLockPayTo,
    initialAdvancedFilters,
    hasUnappliedAdvancedFilters,
    onChangeAdvancedFilters,
  } = params;
  const screenState = useScreenState();

  const isFiltersTab = activeTabId === FILTERS_TAB_ID;
  const isAdvancedFiltersTab = activeTabId === ADVANCED_FILTERS_TAB_ID;

  return (
    <AllFiltersProvider
      open={open}
      onClose={onClose}
      onExited={onExited}
      applyButton={<CreativesTrackerApplyButton />}
      title={null}
      withClearFilters={isFiltersTab}
      tabs={
        <Tabs
          value={activeTabId}
          onChange={(_e, activeTabId) => setActiveTabId(activeTabId)}
        >
          <Tab label={'Filters'} sx={{ height: 60 }} value={FILTERS_TAB_ID} />
          <Tab
            label={
              <AdvancedFiltersLabel
                title={'Advanced Filters'}
                changed={hasUnappliedAdvancedFilters}
                filled={initialAdvancedFilters?.length > 0}
              />
            }
            data-cy-label={'Advanced Filters'}
            sx={{ height: 60 }}
            value={ADVANCED_FILTERS_TAB_ID}
          />
        </Tabs>
      }
    >
      {isFiltersTab ? (
        <React.Fragment>
          <GeneralSection
            payToLocked={payToLocked}
            onLockPayTo={onLockPayTo}
            filters={CreativesTrackerFilters}
          />
          <CreativeSection filters={CreativeFilters} />
        </React.Fragment>
      ) : null}
      {isAdvancedFiltersTab ? (
        <AdvancedFilters
          onChange={onChangeAdvancedFilters}
          values={initialAdvancedFilters}
          loadMetricsOperators={loadMetricsAdvancedOperators}
          loadMetricsList={loadMetricsAdvancedList}
          dimension={screenState.dimension}
        />
      ) : null}
    </AllFiltersProvider>
  );
};

export default AllFilters;
